const PRODUCT_NAME_COLUMN = 'Item[Item Description]';

export function distinctProductNames(rows: any[]): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const row of rows || []) {
    const name = row?.[PRODUCT_NAME_COLUMN];
    if (typeof name !== 'string') { continue; }
    if (!name || name === '-') { continue; }
    if (seen.has(name)) { continue; }
    seen.add(name);
    out.push(name);
  }
  return out;
}

export interface ProductNameFilterPayload {
  name: 'Product';
  code: typeof PRODUCT_NAME_COLUMN;
  // The backend's IN clause builder for Item[Item Description] mishandles
  // string values containing spaces ("The Complete Snowboard" → SQL parse
  // error). The codebase's existing convention is `eq` + `text`, where the
  // backend treats a multi-value array as effectively IN (see
  // FilterColumn.vue:580-588 and AutomationFilterSection.vue:129-134).
  operator: 'eq';
  value: string[];
  dataType: 'text';
}

export function buildProductNameFilter(names: string[]): ProductNameFilterPayload | null {
  if (!names || names.length === 0) { return null; }
  return {
    name: 'Product',
    code: PRODUCT_NAME_COLUMN,
    operator: 'eq',
    value: names,
    dataType: 'text',
  };
}
